module.exports = __webpack_public_path__ + "fonts/azeret-mono-v1-latin-600.abe977a.woff";